import { faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { atoms } from '../../css/atoms/atoms.css';
import { Text } from '../Text/Text';

type FieldMessageTone = 'positive' | 'neutral' | 'critical' | 'caution' | 'neutral25' | 'critical25';

export interface FieldMessageProps {
  id?: string;
  message?: string;
  tone?: FieldMessageTone;
}

const resolveMessageIcon = {
  positive: faCheckCircle,
  neutral: undefined,
  critical: faTimesCircle,
  caution: faExclamationTriangle,
  neutral25: undefined,
  critical25: faTimesCircle,
};

export const FieldMessage: React.FC<FieldMessageProps> = ({ id, message, tone }) => {
  const messageIcon = resolveMessageIcon[tone || 'neutral'];

  return (
    <Text id={id} tone={tone} size="small" weight="demibold">
      {messageIcon && (
        <span
          className={atoms({
            paddingRight: 'xxsmall',
          })}
        >
          <FontAwesomeIcon icon={messageIcon} />
        </span>
      )}
      {message}
    </Text>
  );
};
